import { render, staticRenderFns } from "./CompactTab.vue?vue&type=template&id=34af7378&scoped=true&"
import script from "./CompactTab.vue?vue&type=script&lang=js&"
export * from "./CompactTab.vue?vue&type=script&lang=js&"
import style0 from "./CompactTab.vue?vue&type=style&index=0&id=34af7378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34af7378",
  null
  
)

export default component.exports